import { clientLogging } from '@bfa/nextjs-common/services';

import { GQLProgram } from '../gql.generated';
import { getGqlProgram } from './getGqlProgram';

const PROGRAM_DISPLAY_TITLE = {
  legacy: {
    GLAMBAG: 'Glam Bag',
    FULLSIZE: 'BoxyCharm',
    ULTIMATE: 'Glam Bag Ultimate',
    GBX: 'Icon Box',
    REFRESHMENTS: 'Refreshments',
    BB: 'Beauty Boost',
  },
  rebootRename: {
    GLAMBAG: 'IPSY Original',
    FULLSIZE: 'IPSY Extra',
    ULTIMATE: 'Glam Bag Ultimate',
    GBX: 'IPSY Ultimate',
    REFRESHMENTS: 'Refreshments',
    BB: 'Beauty Boost',
  },
};

export const getProgramDisplayTitle = (
  program: GQLProgram | null,
  cmsDisplayTitle?: string | null,
  isRebootRenameOn?: boolean
): string => {
  if (cmsDisplayTitle) return cmsDisplayTitle;

  const programNames = isRebootRenameOn
    ? PROGRAM_DISPLAY_TITLE.rebootRename
    : PROGRAM_DISPLAY_TITLE.legacy;

  if (program && program === GQLProgram.CREATOR_SEED) {
    clientLogging.logInfo({
      content: 'Unexpected usage of CREATOR_SEED program',
    });

    return programNames[GQLProgram.GLAMBAG];
  }

  if (program) {
    return programNames[program];
  }

  return programNames[GQLProgram.GLAMBAG];
};

export const getProgram = (
  program: string | string[] | undefined
): GQLProgram => {
  if (program === 'BOXYCHARM' || program === 'FULLSIZE') {
    return getGqlProgram('FULLSIZE') as GQLProgram;
  }
  return getGqlProgram('GLAMBAG') as GQLProgram;
};
